import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Menu } from 'src/app/types';

@Component({
  selector: 'app-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  readonly menus = input<Menu[]>([]);
  readonly parentClubLogo = input<string>('');
  readonly toggleLeftNavEventEmitter = output<Menu>({ alias: 'toggleLeftNav' });
  readonly logoutNavEventEmitter = output<void>({ alias: 'logoutNavEventEmitter' });

  protected selectedMenuIndex = 0;

  protected menuSelected(menu: Menu, i: number): void {
    this.selectedMenuIndex = this.selectedMenuIndex === i ? -1 : i;
    this.toggleLeftNavEventEmitter.emit(menu);
  }

  protected logout(): void {
    this.logoutNavEventEmitter.emit();
  }

  protected mouseEnterToMenu(index: number): void {
    this.selectedMenuIndex = index;
  }

  protected mouseLeaveToMenu(_index: number): void {
    this.selectedMenuIndex = -1;
  }
}
